module.exports = __webpack_public_path__ + "img/283.6ebd070b.jpg";